import { TEST } from "../actions/types";
import testReducer from "../reducers/test";
import { flattenTasks } from "../utills/logicUtils";

let taskFlowsTaskDeleteModalOpen = false;

const cloneDeep = (value) => (typeof structuredClone === "function" ? structuredClone(value) : JSON.parse(JSON.stringify(value)));

const getTaskId = (task) => {
  if (!task) return null;
  if (typeof task === "string" || typeof task === "number") return String(task);
  return String(task.id || task.task_id || task.taskId || task._id || "");
};

const getDeletedTaskIds = (prevTasks = [], nextTasks = []) => {
  const nextTaskIds = new Set(nextTasks.map(getTaskId).filter(Boolean));

  return prevTasks
    .map(getTaskId)
    .filter(Boolean)
    .filter((taskId) => !nextTaskIds.has(taskId));
};

const getTaskFlowsUsingDeletedTasks = (taskFlows = [], deletedTaskIds = []) => {
  const deletedSet = new Set(deletedTaskIds.map(String));

  return taskFlows
    .map((taskFlow, taskFlowIndex) => {
      const usedDeletedTaskIds = (taskFlow.tasks || []).map(getTaskId).filter((taskId) => deletedSet.has(taskId));

      return {
        taskFlow,
        taskFlowIndex,
        usedDeletedTaskIds,
      };
    })
    .filter((item) => item.usedDeletedTaskIds.length > 0);
};

const removeDeletedTasksFromTaskFlows = (taskFlows = [], deletedTaskIds = []) => {
  const deletedSet = new Set(deletedTaskIds.map(String));

  return taskFlows.map((taskFlow) => ({
    ...taskFlow,
    tasks: (taskFlow.tasks || []).filter((task) => {
      const taskId = getTaskId(task);
      return !deletedSet.has(taskId);
    }),
  }));
};

export const TaskFlowsTaskVerificationMiddleware = (store) => (next) => (action) => {
  if (action.type !== TEST.UPDATE) return next(action);
  if (action.meta?.skipValidation) return next(action);

  const prevTest = store.getState().test;
  const prevDataRef = prevTest?.data;

  const prevTasks = flattenTasks(prevDataRef?.tasks || []);
  const prevTaskFlows = prevDataRef?.taskFlows || [];

  if (!prevTasks.length || !prevTaskFlows.length) {
    return next(action);
  }

  const nextTestState = testReducer(prevTest, action);
  const nextData = nextTestState?.data || {};

  const nextTasks = flattenTasks(nextData.tasks || []);
  const nextTaskFlows = nextData.taskFlows || prevTaskFlows;

  const deletedTaskIds = getDeletedTaskIds(prevTasks, nextTasks);

  if (!deletedTaskIds.length) {
    return next(action);
  }

  const affectedTaskFlows = getTaskFlowsUsingDeletedTasks(nextTaskFlows, deletedTaskIds);

  if (!affectedTaskFlows.length) {
    return next(action);
  }

  if (taskFlowsTaskDeleteModalOpen) return;

  taskFlowsTaskDeleteModalOpen = true;

  const prevData = cloneDeep(prevDataRef);

  store.dispatch({
    type: TEST.SHOW_UPDATE_CONFIRMATION_MODAL,
    payload: {
      confirmationFor: TEST.CONFIRMATION_FOR.TASK_FLOWS_TASK_DELETE,
      show: true,
      errorMessage: {
        deletedTaskIds,
        affectedTaskFlows,
      },

      onProceed: () => {
        taskFlowsTaskDeleteModalOpen = false;

        const updatedTaskFlows = removeDeletedTasksFromTaskFlows(nextTaskFlows, deletedTaskIds);

        store.dispatch({
          type: TEST.UPDATE,
          meta: { skipValidation: true },
          payload: {
            data: {
              ...nextData,
              taskFlows: updatedTaskFlows,
            },
          },
        });
      },

      onCancel: () => {
        taskFlowsTaskDeleteModalOpen = false;

        store.dispatch({
          type: TEST.UPDATE,
          meta: { skipValidation: true },
          payload: {
            data: prevData,
          },
        });
      },
    },
  });

  return;
};
